module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="invite-cards">\n    <div class="invite-cards__loader">\n        <div class="circle-loader"></div>\n    </div>\n    <div class="invite-cards__content" style="display: none">\n        <header class="invite-cards__header">\n            <div>\n                You have\n                <strong><span class="js-count"></span> interview\n                invite<span class="js-count-s"></span></strong>!\n                <br />\n                Please take a minute to respond:\n            </div>\n            <img src="' +
__e( $.staticURL('application-invite-' + gender + '.svg') ) +
'" />\n        </header>\n        <div class="invite-cards__cards"></div>\n        <footer class="invite-cards__footer">\n            ';
 if (showSkip) { ;
__p += '\n                <a href="#" class="invite-cards__skip">Skip</a>\n            ';
 } else { ;
__p += '\n                <a href="/">Return to home</a>\n            ';
 } ;
__p += '\n        </footer>\n    </div>\n</section>\n';

}
return __p
}